export const GET_ALL_LOG_REQUEST = "GET_ALL_LOG_REQUEST";
export const GET_ALL_LOG_SUCCESS = "GET_ALL_LOG_SUCCESS";
export const GET_ALL_LOG_FAILURE = "GET_ALL_LOG_FAILURE";
